var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('div',{attrs:{"id":"CloseButton"},on:{"click":_vm.Handle_OnClickClose}},[_c('img',{attrs:{"src":require("@/assets/image/btn-close.svg"),"width":"30","height":"30"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }